<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">이벤트</h2>
                </div>
                <div class="contents-area__inner">
                    <router-board code="event" skin="event" />
                </div>
            </div>
        </v-container>
    </component>
</template>
<script>
import RouterBoard from "@/components/client/board/router-board.vue";
export default {
    components: {
        RouterBoard,
    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.default}`); }
    },
}
</script>